import { createContext, useContext, ReactNode, useState, useEffect, useMemo } from "react";

// Define the context
interface TitleContextProps {
  title: string;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
}

const TitleContext = createContext<TitleContextProps | undefined>(undefined);

// Define the context provider
interface TitleProviderProps {
  children: ReactNode;
}

const TitleProvider: React.FC<TitleProviderProps> = ({ children }) => {
  const [title, setTitle] = useState<string>("");

  const value = useMemo(() => {
    return { title, setTitle };
  }, [title]);

  useEffect(() => {
    document.title = title;
  }, [title]);

  return <TitleContext.Provider value={value}>{children}</TitleContext.Provider>;
};

// Custom hook to use the title context
const useTitle = () => {
  const context = useContext(TitleContext);

  if (!context) {
    throw new Error("useTitle must be used within a TitleProvider");
  }

  return context;
};

export { TitleProvider, useTitle };
